import { getCacheItem } from './cacheManager';
import store from './store';
import setStatus from './setStatus';
import set from './set';
import setQuery from './setQuery';

export default (cacheKey) => {
  const connectedCache = getCacheItem(cacheKey);

  if (!connectedCache) {
    return null;
  }

  const state = store.getState();

  const { isStale } = connectedCache;

  return {
    set: (update, options = {}) => set({ update, options, cacheKey }),
    setStatus: (status) => setStatus({ status, cacheKey }),
    setQuery: (update, options = {}) => setQuery({ update, options, cacheKey }),
    getQuery: () => connectedCache.query,
    ...state[cacheKey],
    isStale,
  };
};
